import React, { Component } from 'react'
import { ArticleApi, ArticleAuditApi } from 'trill-api-admin-client'
import {
  Dimmer,
  Loader,
  Header,
  Icon,
  Label,
  Button,
  Menu,
  Divider,
  Popup,
  Modal,
  Statistic,
  Grid,
  List,
  Sidebar,
} from 'semantic-ui-react'
import _ from 'lodash'
import moment from 'moment'

import ArticleFilterContainer from '../../../components/ArticleFilterContainer'
import ArticleDataTable from '../../../components/ArticleDataTable'
import ApiErrorMessage from '../../../components/ApiErrorMessage'
import CategoriesDropdown from '../../../components/CategoriesDropdown'

import GetPermission from '../../../GetPermission'
import CancelablePromise from '../../../CancelablePromise'

import { extractFilenameFromContentDisposition, saveDataAsTsvFile } from '../../../utils/SaveDataAsTsvFile'
import { differenceObject } from '../../../util'

import {
  MAX_ARTICLES_CSV_ROWS,
  ITEMS_PER_PAGE_OPTIONS,
  DEFAULT_ITEMS_PER_PAGE,
  ARTICLES_CHANGE_DATA,
} from '../../../constants/Article'

import {
  ArticleUserAuditStatus,
  ArticleUserAuditStatusText,
  ArticleUserAuditStatusColor,
  ArticleAuditEvaluateStatus,
  ArticleAuditEvaluateStatusText,
  ArticleAuditEvaluateStatusColor,
  ArticleAuditRiskLevel,
} from '../../../enums/ArticleAudit'
import { ArticleStatus } from '../../../enums/Article'

const articleApi = new ArticleApi()
const articleAuditApi = new ArticleAuditApi()

let deleteArticle
let getArticleAudits
let changeArticles = []
let restoreArticles = []
let systemAuditArticles = []

class ArticleAudits extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isBusy: false,
      apiError: null,
      permission: GetPermission('article'),

      tabs: [
        {
          key: '',
          content: 'すべて',
          isActive: true,
        },
        {
          key: ArticleUserAuditStatus.UNREVIEW,
          content: ArticleUserAuditStatusText[ArticleUserAuditStatus.UNREVIEW],
          isActive: false,
        },
        {
          key: ArticleUserAuditStatus.REQUIRES_REVISION,
          content: ArticleUserAuditStatusText[ArticleUserAuditStatus.REQUIRES_REVISION],
          isActive: false,
        },
        {
          key: ArticleUserAuditStatus.REQUIRES_CONSULTATION,
          content: ArticleUserAuditStatusText[ArticleUserAuditStatus.REQUIRES_CONSULTATION],
          isActive: false,
        },
        {
          key: ArticleUserAuditStatus.REVIEWED,
          content: ArticleUserAuditStatusText[ArticleUserAuditStatus.REVIEWED],
          isActive: false,
        },
        {
          key: ArticleUserAuditStatus.REVIEW_NOT_REQUIRED,
          content: ArticleUserAuditStatusText[ArticleUserAuditStatus.REVIEW_NOT_REQUIRED],
          isActive: false,
        },
      ],

      downloadCsvModalData: {
        isOpen: false,
        onSubmit: () => {},
      },

      isFormSearchValid: false,
      filterData: {
        textType: 'keyword',
        text: '',
        status: null,
        mediumIds: [],
        categoryIds: [],
        managementCategoryIds: [],
        sponsorIds: [],
        type: null,
        mediumItem: {
          autoPublish: null,
          shannonSubmissionAllowed: null,
          aiAuditAutoPublishEnabled: null,
        },
        createDateRangeStartAt: moment().startOf('day'),
        createDateRangeEndAt: moment().endOf('day'),
        clearCreateDateRange: true,
        publishDateRangeStartAt: moment().startOf('day'),
        publishDateRangeEndAt: moment().endOf('day'),
        clearPublishDateRange: true,
        restrictedWordTypes: [],
        articleEvaluateStatuses: [],
        articleSystemAudit: {
          articleDuplicated: null,
          originalArticleRiskLevel: null,
          mediumRelatedArticleRiskLevel: null,
        },
      },
      filterKeys: {
        basic: [
          'text',
          'textType',
          'createDateRangeStartAt',
          'createDateRangeEndAt',
          'clearCreateDateRange',
          'publishDateRangeStartAt',
          'publishDateRangeEndAt',
          'clearPublishDateRange',
          'mediumIds',
          'mediumItem.autoPublish',
          'mediumItem.shannonSubmissionAllowed',
          'status',
          'articleEvaluateStatuses',
        ],
        advanced: [
          'mediumItem.aiAuditAutoPublishEnabled',
          'articleSystemAudit.articleDuplicated',
          'articleSystemAudit.originalArticleRiskLevel',
          'articleSystemAudit.mediumRelatedArticleRiskLevel',
          'type',
          'categoryIds',
          'sponsorIds',
          'restrictedWordTypes',
        ],
      },

      sortData: {
        id: 'desc',
      },

      tableData: {
        selectedItemData: {},
        items: [],
        totalPages: 0,
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
      },

      articleDeleteModalData: {
        isOpen: false,
        error: null,
        article: null,
      },

      changeArticlesModalData: {
        isOpen: false,
        error: null,
        type: null,
        status: null,
        categoryId: null,
      },
    }

    this.applyFilteringFromParams()

    this.handlePageRestoredFromBfCache = this.handlePageRestoredFromBfCache.bind(this)
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('pageshow', this.handlePageRestoredFromBfCache)

    this.retrieveArticleAudits()
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handlePageRestoredFromBfCache)

    if (!_.isNil(getArticleAudits)) {
      getArticleAudits.cancel()
    }

    if (!_.isNil(deleteArticle)) {
      deleteArticle.cancel()
    }

    if (!_.isEmpty(changeArticles)) {
      _.each(changeArticles, changeArticle => changeArticle.cancel())
      changeArticles = []
    }

    if (!_.isEmpty(restoreArticles)) {
      _.each(restoreArticles, restoreArticle => restoreArticle.cancel())
      restoreArticles = []
    }

    if (!_.isEmpty(systemAuditArticles)) {
      _.each(systemAuditArticles, systemAuditArticle => systemAuditArticle.cancel())
      systemAuditArticles = []
    }
  }

  handlePageRestoredFromBfCache(event) {
    if (event.persisted) {
      window.location.reload()
    }
  }

  handleTabItemClick = item => {
    const { tabs } = this.state

    _.each(tabs, tab => {
      tab.isActive = _.isEqual(tab.key, item.key)
    })

    this.setState({ tabs }, () => {
      this.retrieveArticleAudits()
    })
  }

  handleFormSearchValid = () => {
    this.setState({ isFormSearchValid: true })
  }

  handleFormSearchInvalid = () => {
    this.setState({ isFormSearchValid: false })
  }

  handleDataTableSelectionChange = (event, { selectedItems, sort, isHeaderCellClick }) => {
    if (isHeaderCellClick) {
      this.setState({ sortData: sort }, () => {
        this.retrieveArticleAudits()
      })
    } else {
      const { tableData } = this.state

      tableData.selectedItemData = selectedItems
      this.setState({ tableData })
    }
  }

  handleDataTablePageChange = (event, { currentPage, itemsPerPage }) => {
    const { tableData } = this.state
    tableData.currentPage = currentPage
    tableData.itemsPerPage = itemsPerPage

    this.setState({ tableData }, () => {
      this.retrieveArticleAudits()
    })
  }

  handleFilterChange = filter => {
    const { filterData } = this.state
    const filterDiff = differenceObject(filter, filterData)
    if (_.isNil(filter) || _.isEmpty(filterDiff)) {
      return
    }

    this.setState({ filterData: filter }, () => {
      const filterDiffKeys = _.keys(filterDiff)
      if (_.isEqual(filterDiffKeys, ['text']) || _.isEqual(filterDiffKeys, ['textType'])) {
        return
      }

      this.retrieveArticleAudits()
    })
  }

  retrieveArticleAudits = () => {
    this.setState({
      isBusy: true,
      apiError: null,
    })

    getArticleAudits = CancelablePromise(articleApi.getArticles(this.getRequestQuery()))
    getArticleAudits.promise
      .then(response => {
        const articles = response.data
        const responseHeader = response.header
        const { tableData } = this.state

        tableData.selectedItemData = {}
        tableData.items = articles
        tableData.totalPages = parseInt(_.get(responseHeader, 'pagination-totalpages', 1), 10)
        tableData.totalItems = parseInt(_.get(responseHeader, 'pagination-totalitems', _.size(articles)), 10)
        tableData.currentPage = parseInt(_.get(responseHeader, 'pagination-currentpage', 1), 10)
        tableData.itemsPerPage = parseInt(_.get(responseHeader, 'pagination-itemsperpage', DEFAULT_ITEMS_PER_PAGE), 10)
        this.setState({
          isBusy: false,
          tableData,
        })
      })
      .catch(error => {
        if (error.isCanceled) {
          return
        }

        const { tableData } = this.state

        tableData.selectedItemData = {}
        tableData.items = []
        tableData.itemsPerPage = DEFAULT_ITEMS_PER_PAGE
        tableData.currentPage = 1
        tableData.totalPages = 0
        tableData.totalItems = 0

        this.setState({
          isBusy: false,
          apiError: error,
          tableData,
        })
      })
  }

  getRequestQuery() {
    const { tabs, filterData, sortData, tableData } = this.state
    const filtering = ["mediumName NOT LIKE '%TRILL%'", 'deletedAt IS NULL']

    const activeTab = _.find(tabs, tab => tab.isActive)
    if (!_.isEmpty(activeTab.key)) {
      filtering.push(`articleUserAuditStatus = '${activeTab.key}'`)
    }

    const articleEvaluateStatuses = filterData.articleEvaluateStatuses
    if (!_.isEmpty(articleEvaluateStatuses)) {
      const filterEvaluateStatusOperator = articleEvaluateStatuses.length > 1 ? 'IN' : '='
      const filterEvaluateStatusValue = articleEvaluateStatuses.join('__AND__')
      filtering.push(`articleEvaluateStatus ${filterEvaluateStatusOperator} '${filterEvaluateStatusValue}'`)
    }

    if (!_.isEmpty(filterData.status)) {
      filtering.push(`status = '${filterData.status}'`)
    }

    const filteringTextValue = filterData.text?.match(/,/g) ? '' : filterData.text
    const filteringTextType = filterData.textType
    if (!_.isEmpty(filteringTextValue) && !_.isEmpty(filteringTextType)) {
      const filter = _.isEqual(filteringTextType, 'id')
        ? `${filteringTextType} = '${filteringTextValue}'`
        : `${filteringTextType} LIKE '%${filteringTextValue}%'`

      filtering.push(filter)
    }

    if (!filterData.clearCreateDateRange) {
      const createDateRangeStartAt = filterData.createDateRangeStartAt
      const createDateRangeEndAt = filterData.createDateRangeEndAt
      filtering.push(`createdAt >= '${createDateRangeStartAt.toISOString()}'`)
      filtering.push(`createdAt <= '${createDateRangeEndAt.toISOString()}'`)
    }

    if (!filterData.clearPublishDateRange) {
      const publishDateRangeStartAt = filterData.publishDateRangeStartAt
      const publishDateRangeEndAt = filterData.publishDateRangeEndAt
      filtering.push(`publishDatetime >= '${publishDateRangeStartAt.toISOString()}'`)
      filtering.push(`publishDatetime <= '${publishDateRangeEndAt.toISOString()}'`)
    }

    // Purpose: Using status index, to speed up query
    if (!filterData.clearPublishDateRange && _.isEmpty(filterData.status)) {
      filtering.push(
        `status IN '${[ArticleStatus.PUBLISH, ArticleStatus.PENDING, ArticleStatus.DRAFT].join('__AND__')}'`,
      )
    }

    _.mapKeys(filterData.mediumItem, (value, key) => {
      if (_.isNull(value)) {
        return
      }

      filtering.push(`mediumItem${_.upperFirst(key)} = ${value}`)
    })

    if (!_.isEmpty(filterData.mediumIds)) {
      const filterMediumOperator = filterData.mediumIds.length > 1 ? 'IN' : '='
      const filterMediumValue = filterData.mediumIds.join('__AND__')
      filtering.push(`mediumId ${filterMediumOperator} '${filterMediumValue}'`)
    }

    if (!_.isEmpty(filterData.categoryIds)) {
      const filterCategoryOperator = filterData.categoryIds.length > 1 ? 'IN' : '='
      const filterCategoryValue = filterData.categoryIds.join('__AND__')
      filtering.push(`categoryId ${filterCategoryOperator} '${filterCategoryValue}'`)
    }

    if (!_.isEmpty(filterData.managementCategoryIds)) {
      const filterCategoryOperator = filterData.managementCategoryIds.length > 1 ? 'IN' : '='
      const filterCategoryValue = filterData.managementCategoryIds.join('__AND__')
      filtering.push(`managementCategoryId ${filterCategoryOperator} '${filterCategoryValue}'`)
    }

    if (!_.isEmpty(filterData.sponsorIds)) {
      const filterSponsorOperator = filterData.sponsorIds.length > 1 ? 'IN' : '='
      const filterSponsorValue = filterData.sponsorIds.join('__AND__')
      filtering.push(`sponsorId ${filterSponsorOperator} '${filterSponsorValue}'`)
    }

    if (!_.isEmpty(filterData.restrictedWordTypes)) {
      const filterRestrictedWordsOperator = filterData.restrictedWordTypes.length > 1 ? 'IN' : '='
      const filterRestrictedWordsValue = filterData.restrictedWordTypes.join('__AND__')
      filtering.push(`restrictedWordType ${filterRestrictedWordsOperator} '${filterRestrictedWordsValue}'`)
    }

    if (_.isEqual(filterData.type, 'sponsored')) {
      filtering.push('sponsor_id IS NOT NULL')
    }

    if (_.isEqual(filterData.type, 'video_only')) {
      filtering.push("thumbnail LIKE '%video%'")
      filtering.push("cover LIKE '%video%'")
    }

    if (_.isEqual(filterData.type, 'video_cantidate_only')) {
      filtering.push("description LIKE '%www.youtube.com/embed%'")
      filtering.push("thumbnail NOT LIKE '%video%'")
      filtering.push("cover NOT LIKE '%video%'")
    }

    _.mapKeys(filterData.articleSystemAudit, (value, key) => {
      if (_.isNull(value)) {
        return
      }

      filtering.push(`articleSystemAudit${_.upperFirst(key)} = '${value}'`)
    })

    const totalPage = Math.ceil(tableData.totalItems / tableData.itemsPerPage)
    const currentPage = Math.min(tableData.currentPage, Math.max(totalPage, 1))
    const itemsPerPage = tableData.itemsPerPage

    const sorting = _.map(sortData, (value, key) => {
      const prefix = _.isEqual(value, 'desc') ? '-' : ''
      return prefix.concat(key)
    })

    const query = {
      filtering,
      sorting,
      currentPage,
      itemsPerPage,
    }

    return _.omitBy(query, value => !_.isNumber(value) && _.isEmpty(value))
  }

  handleDownloadArticlesCsv = () => {
    this.setState({
      isBusy: true,
      apiError: null,
    })

    const currentPage = 1
    const requestQuery = {
      ...this.getRequestQuery(),
      itemsPerPage: MAX_ARTICLES_CSV_ROWS,
      currentPage,
      articleTemplate: 'article-audits',
    }
    articleApi
      .downloadArticlesCsv(requestQuery)
      .then(response => {
        const responseHeader = response.header
        const isHasNextPage = Boolean(_.get(responseHeader, 'has-more-items', 'false'))

        const fileName = extractFilenameFromContentDisposition(
          _.get(responseHeader, 'content-disposition', ''),
          'articles.tsv',
        )
        const content = response.data
        const contentType = _.get(responseHeader, 'content-type', 'text/tsv; charset=utf-8')

        const partialState = { isBusy: false }
        if (isHasNextPage) {
          partialState.downloadCsvModalData = {
            isOpen: true,
            onSubmit: () => {
              saveDataAsTsvFile(fileName, content, contentType)
              this.handleDownloadCsvModalCancelButtonClick()
            },
          }
        } else {
          saveDataAsTsvFile(fileName, content, contentType)
        }

        this.setState(partialState)
      })
      .catch(error => {
        this.setState({
          isBusy: false,
          apiError: error,
        })
      })
  }

  handleDownloadCsvModalCancelButtonClick = () => {
    const downloadCsvModalData = {
      isOpen: false,
      onSubmit: () => {},
    }
    this.setState({ downloadCsvModalData })
  }

  handleArticleDeleteModalOpen = article => {
    const articleDeleteModalData = {
      isOpen: true,
      error: null,
      article,
    }

    this.setState({ articleDeleteModalData })
  }

  handleArticleDeleteModalClose = () => {
    const articleDeleteModalData = {
      isOpen: false,
      error: null,
      article: null,
    }

    this.setState({ articleDeleteModalData })
  }

  handleSubmitButtonArticleDeleteModalClick = () => {
    this.setState({
      isBusy: true,
    })

    const { articleDeleteModalData } = this.state
    const articleId = _.get(articleDeleteModalData, 'article.id')

    deleteArticle = CancelablePromise(articleApi.deleteArticle(articleId))
    deleteArticle.promise
      .then(() => {
        articleDeleteModalData.isOpen = false
        articleDeleteModalData.article = null
        this.setState({
          isBusy: false,
          articleDeleteModalData,
        })

        this.retrieveArticleAudits()
      })
      .catch(error => {
        articleDeleteModalData.error = error
        this.setState({
          isBusy: false,
          articleDeleteModalData,
        })
      })
  }

  handleDeselectArticlesButtonClick = () => {
    const { tableData } = this.state

    tableData.selectedItemData = {}
    this.setState({ tableData })
  }

  handleChangeArticlesModalOpen = ({ type, status }) => {
    const changeArticlesModalData = {
      isOpen: true,
      error: null,
      type,
      status,
      categoryId: null,
    }

    this.setState({ changeArticlesModalData })
  }

  handleChangeArticlesModalClose = () => {
    const changeArticlesModalData = {
      isOpen: false,
      error: null,
      type: null,
      status: null,
      categoryId: null,
    }

    this.setState({ changeArticlesModalData })
  }

  handleCategoryIdChangeArticlesModalChange = (event, { value }) => {
    const { changeArticlesModalData } = this.state

    changeArticlesModalData.categoryId = value
    this.setState({ changeArticlesModalData })
  }

  handleSubmitButtonChangeArticlesModalClick = () => {
    this.setState({
      isBusy: true,
    })

    const { tableData, changeArticlesModalData } = this.state

    changeArticles = []
    restoreArticles = []
    systemAuditArticles = []

    _.forEach(tableData.selectedItemData, (value, articleId) => {
      const article = _.find(tableData.items, item => _.isEqual(item.id, parseInt(articleId, 10)))
      const articleSystemAuditId = _.get(article, 'articleSystemAudit.id')
      let articleUpdateValues = {}

      switch (changeArticlesModalData.type) {
        case 'status':
          if (_.isEqual(changeArticlesModalData.status, ArticleStatus.TRASH)) {
            changeArticles.push(CancelablePromise(articleApi.deleteArticle(articleId)))
          } else {
            if (!_.isNil(article.deletedAt)) {
              restoreArticles.push(CancelablePromise(articleApi.putArticle(articleId)))
            }

            articleUpdateValues = { status: changeArticlesModalData.status }
            changeArticles.push(CancelablePromise(articleApi.patchArticle(articleId, { articleUpdateValues })))
          }
          break

        case 'category':
          articleUpdateValues = { categoryId: _.defaultTo(changeArticlesModalData.categoryId, 0) }
          changeArticles.push(CancelablePromise(articleApi.patchArticle(articleId, { articleUpdateValues })))
          break

        case 'system-audit':
          if (_.isNil(articleSystemAuditId)) {
            systemAuditArticles.push(CancelablePromise(articleAuditApi.postArticleSystemAudits(articleId)))
          } else {
            systemAuditArticles.push(
              CancelablePromise(articleAuditApi.patchArticleSystemAudit(articleId, articleSystemAuditId)),
            )
          }
          break

        default:
          break
      }
    })

    Promise.all(_.map(restoreArticles, restoreArticle => restoreArticle.promise))
      .then(() => Promise.all(_.map(changeArticles, changeArticle => changeArticle.promise)))
      .then(() => Promise.all(_.map(systemAuditArticles, systemAuditArticle => systemAuditArticle.promise)))
      .then(() => {
        changeArticlesModalData.isOpen = false
        changeArticlesModalData.type = null
        changeArticlesModalData.status = null
        changeArticlesModalData.categoryId = null
        this.setState({
          isBusy: false,
          changeArticlesModalData,
        })

        this.retrieveArticleAudits()
      })
      .catch(error => {
        if (error.isCanceled) {
          return
        }

        changeArticlesModalData.error = error
        this.setState({
          isBusy: false,
          changeArticlesModalData,
        })
      })
  }

  applyFilteringFromParams() {
    const { filterData, tabs } = this.state
    const params = new URLSearchParams(window.location.search)
    const filtering = params.get('filtering')

    if (filtering) {
      const parseFilter = JSON.parse(decodeURIComponent(filtering))
      if (
        !_.isEmpty(parseFilter.articleUserAuditStatus) &&
        _.includes(_.values(ArticleUserAuditStatus), parseFilter.articleUserAuditStatus)
      ) {
        _.each(tabs, tab => {
          tab.isActive = _.isEqual(tab.key, parseFilter.articleUserAuditStatus)
        })
      }

      if (!_.isEmpty(parseFilter.articleEvaluateStatuses)) {
        filterData.articleEvaluateStatuses = Array.isArray(parseFilter.articleEvaluateStatuses)
          ? parseFilter.articleEvaluateStatuses
          : [parseFilter.articleEvaluateStatuses]
      }

      const hasStart = !_.isEmpty(parseFilter.createDateRangeStartAt)
      const hasEnd = !_.isEmpty(parseFilter.createDateRangeEndAt)

      if (hasStart || hasEnd) {
        filterData.clearCreateDateRange = false
        if (hasStart) {
          filterData.createDateRangeStartAt = moment(parseFilter.createDateRangeStartAt)
        }
        if (hasEnd) {
          filterData.createDateRangeEndAt = moment(parseFilter.createDateRangeEndAt)
        }
      }

      if (!_.isUndefined(parseFilter.shannonSubmissionAllowed)) {
        filterData.mediumItem.shannonSubmissionAllowed = parseFilter.shannonSubmissionAllowed
      }

      if (!_.isUndefined(parseFilter.mediumItemAutoPublish)) {
        filterData.mediumItem.autoPublish = parseFilter.mediumItemAutoPublish
      }
    }
  }

  render() {
    const {
      isBusy,
      apiError,
      permission,
      tabs,
      downloadCsvModalData,
      isFormSearchValid,
      filterKeys,
      filterData,
      sortData,
      tableData,
      articleDeleteModalData,
      changeArticlesModalData,
    } = this.state
    const { hasUpdatePermission, hasDeletePermission } = permission

    const currentArticleChangeData = _.find(
      ARTICLES_CHANGE_DATA,
      articleChangeData =>
        _.isEqual(articleChangeData.type, changeArticlesModalData.type) &&
        _.isEqual(articleChangeData.status, changeArticlesModalData.status),
    )

    return (
      <div className="ArticleAudits">
        <Header as="h1" style={{ marginBottom: 0 }}>
          <Icon name="handshake outline" />

          <Header.Content>記事監査</Header.Content>
        </Header>

        <Dimmer active={isBusy} inverted>
          <Loader>読み込み中</Loader>
        </Dimmer>

        <Menu pointing secondary floated style={{ marginTop: '1rem' }}>
          {_.map(tabs, tab => (
            <Menu.Item
              key={tab.key}
              name={tab.key}
              content={tab.content}
              active={tab.isActive}
              onClick={() => this.handleTabItemClick(tab)}
            />
          ))}
        </Menu>

        <Divider hidden clearing />

        <ArticleFilterContainer
          filteringKeys={filterKeys}
          filtering={filterData}
          isFormSearchValid={isFormSearchValid}
          handleFormSearchValid={this.handleFormSearchValid}
          handleFormSearchInvalid={this.handleFormSearchInvalid}
          handleFilterChange={this.handleFilterChange}
          handleSearchButtonClick={this.retrieveArticleAudits}
        />

        <Grid verticalAlign="bottom" centered style={{ margin: '0 -1rem' }}>
          <Grid.Row columns={2}>
            <Grid.Column floated="left" width={4}>
              {!_.isEmpty(tableData.items) && _.isEmpty(apiError) && (
                <Statistic horizontal size="mini" color="grey">
                  <Statistic.Value>{tableData.totalItems}</Statistic.Value>
                  <Statistic.Label>件</Statistic.Label>
                </Statistic>
              )}
            </Grid.Column>

            <Grid.Column floated="right" width={12}>
              <Button
                disabled={_.isEmpty(tableData.items)}
                primary
                floated="right"
                icon="download"
                labelPosition="right"
                content="TSVダウンロード"
                onClick={this.handleDownloadArticlesCsv}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <ApiErrorMessage error={apiError} />

        {!_.isEmpty(tableData.items) && (
          <div
            className="ArticleAudits__DataTable"
            style={{
              marginBottom: _.isEmpty(tableData.selectedItemData) ? '0' : '4rem',
            }}
          >
            <ArticleDataTable
              isTopFooter
              selectable={true}
              selectedItems={tableData.selectedItemData}
              articles={tableData.items}
              filtering={_.pick(filterData, ['restrictedWordTypes'])}
              sort={sortData}
              itemsPerPageOptions={ITEMS_PER_PAGE_OPTIONS}
              currentPage={tableData.currentPage}
              itemsPerPage={tableData.itemsPerPage}
              totalPages={tableData.totalPages}
              onSelectionChange={this.handleDataTableSelectionChange}
              onPageChange={this.handleDataTablePageChange}
              ignoreColumns={[
                {
                  key: 'categoryName',
                },
                {
                  key: 'managementCategoryName',
                },
              ]}
              extColumns={[
                {
                  key: 'ArticleUserAuditStatus',
                  label: '監査状況',
                  align: 'center',
                  render: item => {
                    const userAuditStatus = _.get(item, 'articleUserAudit.status')
                    if (!_.isEmpty(userAuditStatus)) {
                      return (
                        <Label style={{ backgroundColor: ArticleUserAuditStatusColor[userAuditStatus], color: '#fff' }}>
                          {ArticleUserAuditStatusText[userAuditStatus]}
                        </Label>
                      )
                    }

                    return null
                  },
                },
                {
                  key: 'ArticleAuditEvaluateStatus',
                  labelRender: () => (
                    <span style={{ fontSize: 10 }}>
                      AI記事監査
                      <br />
                      ステータス
                    </span>
                  ),
                  align: 'center',
                  render: item => {
                    const isMediumItemAiAuditEnabled = _.get(item, 'mediumItem.aiAuditEnabled', false)
                    const articleEvaluates = _.get(item, 'articleEvaluateStatuses', [])

                    const externalStatus =
                      !isMediumItemAiAuditEnabled || _.isEmpty(articleEvaluates)
                        ? ArticleAuditEvaluateStatus.EXCEPTION
                        : null

                    return (
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {!_.isNil(externalStatus) && (
                          <Label
                            key={externalStatus}
                            style={{
                              width: '100%',
                              margin: '0.25rem 0',
                              backgroundColor: ArticleAuditEvaluateStatusColor[externalStatus],
                              color: '#fff',
                            }}
                          >
                            {ArticleAuditEvaluateStatusText[externalStatus]}
                          </Label>
                        )}

                        {!_.isEmpty(articleEvaluates) &&
                          _.map(articleEvaluates, articleEvaluate => (
                            <Label
                              key={articleEvaluate.id}
                              style={{
                                width: '100%',
                                margin: '0.25rem 0',
                                backgroundColor: ArticleAuditEvaluateStatusColor[articleEvaluate.status],
                                color: '#fff',
                              }}
                            >
                              {ArticleAuditEvaluateStatusText[articleEvaluate.status]}
                            </Label>
                          ))}
                      </div>
                    )
                  },
                },
                {
                  key: 'mediumAiAuditAutoPublishEnabled',
                  label: 'AI即時公開',
                  align: 'center',
                  render: item => {
                    const isAiAuditAutoPublishEnabled = _.get(item, 'mediumItem.aiAuditAutoPublishEnabled', false)

                    return isAiAuditAutoPublishEnabled ? (
                      <Label style={{ backgroundColor: '#4023B3', borderColor: '#4023B3', color: '#fff' }}>YES</Label>
                    ) : (
                      <Label color="grey">NO</Label>
                    )
                  },
                },
                {
                  key: 'articleDuplicated',
                  label: '重複判定',
                  align: 'center',
                  render: item => {
                    const isArticleDuplicated = _.get(item, 'articleSystemAudit.articleDuplicated')
                    if (_.isNil(isArticleDuplicated)) {
                      return null
                    }

                    return isArticleDuplicated ? (
                      <Label style={{ backgroundColor: '#4023B3', borderColor: '#4023B3', color: '#fff' }}>YES</Label>
                    ) : (
                      <Label color="grey">NO</Label>
                    )
                  },
                },
                {
                  key: 'originalArticleRiskLevel',
                  label: '元記事差分',
                  align: 'center',
                  render: item => {
                    const originalArticleRiskLevel = _.get(item, 'articleSystemAudit.originalArticleRiskLevel')
                    if (_.isNil(originalArticleRiskLevel)) {
                      return null
                    }

                    const isOriginalArticleHighRisk = _.isEqual(originalArticleRiskLevel, ArticleAuditRiskLevel.HIGH)
                    return isOriginalArticleHighRisk ? (
                      <Label style={{ backgroundColor: '#4023B3', borderColor: '#4023B3', color: '#fff' }}>YES</Label>
                    ) : (
                      <Label color="grey">NO</Label>
                    )
                  },
                },
                {
                  key: 'mediumRelatedArticleRiskLevel',
                  label: '関連記事',
                  align: 'center',
                  render: item => {
                    const mediumRelatedArticleRiskLevel = _.get(
                      item,
                      'articleSystemAudit.mediumRelatedArticleRiskLevel',
                    )
                    if (_.isNil(mediumRelatedArticleRiskLevel)) {
                      return null
                    }

                    const isMediumRelatedArticleHighRisk = _.isEqual(
                      mediumRelatedArticleRiskLevel,
                      ArticleAuditRiskLevel.HIGH,
                    )
                    return isMediumRelatedArticleHighRisk ? (
                      <Label style={{ backgroundColor: '#4023B3', borderColor: '#4023B3', color: '#fff' }}>YES</Label>
                    ) : (
                      <Label color="grey">NO</Label>
                    )
                  },
                },
                {
                  key: 'operate',
                  label: '操作',
                  align: 'center',
                  render: item => (
                    <Button.Group secondary>
                      <Popup
                        inverted
                        wide
                        content="記事の編集"
                        trigger={
                          <Button disabled={!hasUpdatePermission} as="a" icon="edit" href={`/article/${item.id}`} />
                        }
                      />

                      <Popup
                        inverted
                        wide
                        content="記事本文のプレビューを表示"
                        trigger={<Button as="a" icon="zoom-in" href={`/article-preview/${item.id}`} target="_blank" />}
                      />

                      {_.isNil(item.deletedAt) && (
                        <Button
                          disabled={!hasDeletePermission}
                          icon="trash alternate outline"
                          onClick={() => {
                            this.handleArticleDeleteModalOpen(item)
                          }}
                        />
                      )}
                    </Button.Group>
                  ),
                },
              ]}
            />
          </div>
        )}

        <Modal size="tiny" open={downloadCsvModalData.isOpen} closeOnDimmerClick={false}>
          <Modal.Header>注意！</Modal.Header>

          <Modal.Content>
            <p>
              TSV最大出力件数は1万件までです。1万件を超える結果はTSVに出力されませんが、ダウンロードを実行しますか？
            </p>
          </Modal.Content>

          <Modal.Actions>
            <Button content="キャンセル" onClick={this.handleDownloadCsvModalCancelButtonClick} />

            <Button positive content="ダウンロード" onClick={downloadCsvModalData.onSubmit} />
          </Modal.Actions>
        </Modal>

        {hasDeletePermission && (
          <Modal
            closeIcon
            open={articleDeleteModalData.isOpen}
            onClose={this.handleArticleDeleteModalClose}
            closeOnDimmerClick={false}
          >
            <Modal.Header>記事の削除</Modal.Header>

            <Dimmer active={isBusy} inverted>
              <Loader />
            </Dimmer>

            <Modal.Content>
              <ApiErrorMessage error={articleDeleteModalData.error} />

              <p>記事をゴミ箱へ移動しますか？</p>
            </Modal.Content>

            <Modal.Actions>
              <Button content="キャンセル" onClick={this.handleArticleDeleteModalClose} />

              <Button negative content="ゴミ箱へ移動" onClick={this.handleSubmitButtonArticleDeleteModalClick} />
            </Modal.Actions>
          </Modal>
        )}

        <Sidebar
          as={Menu}
          className="massive icon"
          animation="overlay"
          direction="bottom"
          visible={!_.isEmpty(tableData.selectedItemData)}
        >
          <Popup
            inverted
            wide
            content="すべての選択を解除します。"
            trigger={
              <Menu.Item onClick={this.handleDeselectArticlesButtonClick}>
                <Label color="red" size="large">
                  <Icon name="check square" />
                  {_.size(tableData.selectedItemData)}
                </Label>
              </Menu.Item>
            }
          />

          {_.map(
            _.filter(
              ARTICLES_CHANGE_DATA,
              articleChangeData =>
                _.isNil(articleChangeData.status) || !_.isEqual(articleChangeData.status, filterData.status),
            ),
            (articleChangeData, index) => (
              <Popup
                inverted
                wide
                key={index}
                content={articleChangeData.content}
                trigger={
                  <Menu.Item
                    onClick={() => {
                      this.handleChangeArticlesModalOpen({
                        status: articleChangeData.status,
                        type: articleChangeData.type,
                      })
                    }}
                  >
                    <Icon name={articleChangeData.icon} />
                  </Menu.Item>
                }
              />
            ),
          )}
        </Sidebar>

        <Modal
          closeIcon
          open={changeArticlesModalData.isOpen}
          onClose={this.handleChangeArticlesModalClose}
          closeOnDimmerClick={false}
        >
          <Modal.Header>{_.get(currentArticleChangeData, 'header', '')}</Modal.Header>

          <Dimmer active={isBusy} inverted>
            <Loader />
          </Dimmer>

          <Modal.Content>
            <ApiErrorMessage error={changeArticlesModalData.error} />

            {_.isEqual(changeArticlesModalData.type, 'category') && (
              <CategoriesDropdown
                fluid={true}
                categoryId={changeArticlesModalData.categoryId}
                onChange={this.handleCategoryIdChangeArticlesModalChange}
              />
            )}

            <List divided relaxed>
              {!_.isEmpty(tableData.selectedItemData) &&
                _.map(tableData.selectedItemData, (value, id) => {
                  const selectedArticle = _.find(tableData.items, item => _.isEqual(item.id, parseInt(id, 10)))
                  if (_.isNil(selectedArticle)) {
                    return null
                  }

                  return (
                    <List.Item key={id}>
                      <List.Icon name="file text outline" size="large" verticalAlign="middle" />

                      <List.Content>
                        <List.Header>{selectedArticle.title}</List.Header>
                        <List.Description>{selectedArticle.slug}</List.Description>
                      </List.Content>
                    </List.Item>
                  )
                })}
            </List>
          </Modal.Content>

          <Modal.Actions>
            <Button content="キャンセル" onClick={this.handleChangeArticlesModalClose} />

            <Button
              {..._.get(currentArticleChangeData, 'button', {})}
              onClick={this.handleSubmitButtonChangeArticlesModalClick}
            />
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}

export default ArticleAudits
